import React from 'react';
import PT from 'prop-types';
import createFormikField from 'Components/Admin/Form/utils/createFormikField';
import cn from 'classnames';
import connectToFormik from 'Components/Admin/Form/utils/connectToFormik';
import compose from 'lodash/flowRight';

import Input from 'Components/Input';
import {
  Card,
  Currency,
  DatePicker,
  PdfEditor,
  Radio,
  Schedule,
  Select,
  Switches,
  Tabs,
  Toggle,
} from 'Components/Admin/Form/Fields';
import TextArea from 'Components/Admin/Form/components/TextArea/TextArea';

const propTypes = {
  type: PT.oneOf([
    'text',
    'textarea',
    'select',
    'radio',
    'date',
    'tabs',
    'pdf',
    'switches',
    'schedule',
    'currency',
    'card',
    'toggle',
  ]),
  subForm: PT.object,
  onSubmit: PT.func,
  placeholder: PT.string,
  label: PT.string,
  subLabel: PT.string,
};

const Fields = {
  text: createFormikField(Input),
  textarea: compose(createFormikField, connectToFormik)(TextArea),
  currency: compose(createFormikField, connectToFormik)(Currency),
  select: compose(createFormikField, connectToFormik)(Select),
  radio: compose(createFormikField, connectToFormik)(Radio),
  date: compose(createFormikField, connectToFormik)(DatePicker),
  tabs: compose(createFormikField, connectToFormik)(Tabs),
  pdf: compose(createFormikField, connectToFormik)(PdfEditor),
  switches: compose(createFormikField, connectToFormik)(Switches),
  schedule: compose(createFormikField, connectToFormik)(Schedule),
  card: compose(createFormikField, connectToFormik)(Card),
  toggle: compose(createFormikField, connectToFormik)(Toggle),
};

const fieldsManager = (item, index) => {
  if (Array.isArray(item)) {
    return (
      <div className={cn('admin-form__row', item[0].rowClassName)} key={index}>
        {item.map(fieldsManager)}
      </div>
    );
  }

  const { type, ...props } = item;

  const Component = Fields[type] || Fields.text;

  return <Component {...props} key={props.name || index} type={type} />;
};

fieldsManager.propTypes = propTypes;

export default fieldsManager;
